import { EnvironmentInterface } from '@campus/environment';
import { E2eModule } from '../app/e2e/e2e.module';
import { icons } from './icons';
import { svgs } from './svgs';

export const environment: Partial<EnvironmentInterface> = {
  production: true,
  enableDevTools: true,
  svgMapping: svgs,
  iconMapping: icons,
  platform: 'polpo',
  api: {
    APIBase: 'https://api.staging.polpo.be',
    authBase: 'https://api.staging.polpo.be/auth',
  },
  login: {
    url: 'https://api.staging.polpo.be/app/login',
    leerId: true,
    qr: true,
  },
  assets: {
    images: {
      faq: 'https://www.staging.polpo.be/assets/images/faq',
      illustrations: 'https://www.staging.polpo.be/assets/images/illustrations',
      ea: 'https://www.staging.polpo.be/assets/images/ea',
      news: 'https://avatar.staging.kabas.be/',
    },
  },
  recaptcha: {
    key: '6Lc5jgopAAAAAEoCUTxz0hRSbf_5ooJfR4B_oXSI',
  },
  googleAnalytics: {
    measurementId: '',
    requireConsent: true,
  },
  afterLogout: {
    url: '/student/login',
    logOutLeerIdUrl: 'https://authenticatie-ti.vlaanderen.be/op/v1/logout',
  },
  ui: {
    contact: {
      helpdesk: {
        label: 'helpdesk@diekeure.be',
        link: 'mailto:helpdesk@diekeure.be',
      },
    },
  },
  website: {
    url: 'https://staging.polpo.be',
    statusPageUrl: 'https://status.polpo.be',
  },
  testing: {
    removeDataCyAttributes: false,
  },
  envModules: [E2eModule],
};
